import styled, { css } from 'styled-components';
import { imagePulse } from '@/components/media/imagePulse.styles';
import { imageBlurredFadeIn } from '@/components/media/imageLoadedFadeIn.styles';
import { imageFilter } from '@/components/media/imageFilter.styles';

export const MediaWrapper = styled.div`
  ${({ theme }) => {
    return css`
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;
      border-radius: ${theme.radius.sm};

      img {
        object-fit: cover;
        user-select: none;

        ${imageBlurredFadeIn};
      }

      ${imageFilter};
      ${imagePulse};
    `;
  }};
`;
